module.exports = __webpack_public_path__ + "img/info-03.b156dc6b.jpg";